import type { EditableField } from '../../api/types';

export interface InputColumn {
  field: EditableField;
  label: string;
  hint?: string;
  unit?: string;
  decimals: number;
}

export interface ColumnGroup {
  label: string;
  columns: InputColumn[];
}

export const INPUT_GROUPS: ColumnGroup[] = [
  {
    label: 'Objetivos del mes',
    columns: [
      { field: 'minimumExpected', label: 'Mínimo esperable', hint: 'OMM del mes (€)', unit: '€', decimals: 0 },
      { field: 'target', label: 'Objetivo', hint: 'Objetivo del mes (€)', unit: '€', decimals: 0 },
    ],
  },
  {
    label: 'Resultado',
    columns: [{ field: 'salesAmount', label: 'Importe vendido', hint: 'Ventas generadas en el mes (€)', unit: '€', decimals: 0 }],
  },
  {
    label: 'Actividad',
    columns: [
      { field: 'leads', label: 'Leads', hint: 'Leads recibidos', decimals: 0 },
      { field: 'opportunities', label: 'Oportunidades', decimals: 0 },
      { field: 'sales', label: 'Ventas', hint: 'Número de ventas cerradas', decimals: 0 },
      { field: 'calls', label: 'Llamadas', decimals: 0 },
      { field: 'callHours', label: 'Horas llamada', hint: 'Tiempo total en llamada (horas)', decimals: 2 },
      { field: 'daysWorked', label: 'Días trab.', hint: 'Días trabajados en el mes', decimals: 1 },
      { field: 'visits', label: 'Visitas', hint: 'Visitas presenciales totales', decimals: 0 },
    ],
  },
];

export const INPUT_COLUMNS = INPUT_GROUPS.flatMap((g) => g.columns);

export const FIELD_LABELS: Record<string, string> = Object.fromEntries(INPUT_COLUMNS.map((c) => [c.field, c.label]));

/** Display names of the systems that fill values automatically. */
const INTEGRATION_NAMES: Record<string, string> = { radar: 'Radar (llamadas)' };

export function describeSource(source: string | undefined): { label: string; tone: 'excel' | 'integration' | 'manual' } | null {
  if (!source) return null;
  if (source === 'excel_import') return { label: 'Importado del Excel histórico', tone: 'excel' };
  if (source.startsWith('integration:')) {
    const name = source.slice(12);
    return { label: `Integración: ${INTEGRATION_NAMES[name] ?? name}`, tone: 'integration' };
  }
  return { label: 'Introducido manualmente', tone: 'manual' };
}
